import React, {useState} from 'react';

// svg images
import FaqBox from './FaqBox';

const Faq = () => {
  const [contentIndex, setContentIndex] = useState(0);

  const [content] = useState([
    {
      ask: 'هدف این سامانه چیست؟',
      question: `
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک
      است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط
      فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
      کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می
      طلبد
      `,
    },
    {
      ask: 'نحوه ی مدیریت داده در این سامانه چگونه انجام میشود؟',
      question: `
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک
      است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط
      فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
      کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می
      طلبد
      `,
    },
    {
      ask: 'آیا اطلاعات این سامانه در جایی مورد بهره برداری قرار می گیرد؟',
      question: `
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک
      است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط
      فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
      کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می
      طلبد
      `,
    },
    {
      ask: 'موارد استفاده از این سامانه چیست؟',
      question: `
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک
      است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط
      فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
      کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می
      طلبد
      `,
    },
    {
      ask: 'نحوه ی استفاده از اپ به چه صورت است؟',
      question: `
      لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک
      است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط
      فعلی تکنولوژی مورد نیاز، و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد،
      کتابهای زیادی در شصت و سه درصد گذشته حال و آینده، شناخت فراوان جامعه و متخصصان را می
      طلبد
      `,
    },
  ]);

  return (
    <section className="faq-section" id="faq-section">
      <h6 className="faq-box__title">سوالات متداول</h6>
      <div className="faq-box">
        {content.map((item, index) => {
          return (
            <FaqBox
              open={index === contentIndex}
              index={index}
              onSetIndex={setContentIndex}
              ask={item.ask}
              question={item.question}
              // eslint-disable-next-line
              key={index}
            />
          );
        })}
      </div>
    </section>
  );
};

export default Faq;
